import axios from "axios";
import { API_URL } from "@/settings";

const instance = axios.create({
  baseURL: API_URL + "api/auth"
});

export default instance;
